import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-entfernen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenChecklisteEntfernenEffects {

    ChecklisteEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_ENTFERNEN),
        mergeMap((x: ac.PostChecklisteEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteEntfernen(x.checklisteRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteEntfernenErfolgreichAction(result, x.checklisteRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteEntfernenFehlerAction(error, x.checklisteRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
